import { requestCreateTeamRegister } from 'app/api/event'
import { IActionEvent, IPayloadCreateRegisterTeam } from 'app/api/event/model'
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import R from 'app/assets/R'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { notificationController } from 'app/controllers/notification-controller'
import { EventKeys } from 'app/react-query/query-key/event'
import { useAppSelector } from 'app/redux/hooks'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'
import styled from 'styled-components'
import { ModalSelectTum } from './SelectTum'
import TextArea from 'antd/es/input/TextArea'

export const ModalRegisterAction = ({ action }: { action?: IActionEvent }) => {
  const { t } = useTranslation()
  const query = useQueryClient()
  const refModal = useRef<IRefModal>({})
  const [form] = BaseForm.useForm()
  const [dataSelected, setDataSelected] = useState<ITradeUnionMember[]>([])
  const user = useAppSelector(state => state?.user)?.profile
  const [loading, setIsLoading] = useState(false)
  const handleSubmit = async (values: IPayloadCreateRegisterTeam) => {
    try {
      setIsLoading(true)
      if (user?.member?.id && action?.id) {
        const newPayload: IPayloadCreateRegisterTeam = {
          activity_id: action?.id,
          createdById: +(user?.member?.id ?? 0),
          description: values?.description,
          name: values?.name,
          tumIds: dataSelected?.map(itm => +(itm?.id ?? 0)) ?? [],
        }
        const res = await requestCreateTeamRegister(newPayload)
        if (res) {
          notificationController.success({
            message: `Đăng ký hoạt động "${action?.name}" thành công!`,
          })
          query?.invalidateQueries({
            queryKey: EventKeys.allListActionNotJoinByTeam,
          })
          query?.invalidateQueries({
            queryKey: EventKeys.allListActionRegisteredByTeam,
          })
          refModal.current?.hide?.()
        }
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <BaseModalComponent
      ref={refModal}
      titleModal="Đặt kí thông tin đội nhóm tham gia sự kiện"
      buttonOpenModal={
        <BaseButton
          type="primary"
          children="Đăng ký"
          onClick={() => refModal.current?.open?.()}
        />
      }
      handleSubmit={form.submit}
      isLoadingConfirm={loading}
      isDisableSubmit={!dataSelected?.length}
      renderContent={
        <BaseSpace size={8}>
          <BaseForm form={form} onFinish={handleSubmit}>
            <BaseSpace size={0}>
              <BaseFormItem
                name={'name'}
                label={'Tên đội'}
                required
                rules={[
                  {
                    required: true,
                    message: t(R.strings.require_field, { field: 'Tên đội' }),
                  },
                ]}
              >
                <BaseInput placeholder="Nhập tên đội" />
              </BaseFormItem>

              <BaseFormItem name={'description'} label={'Mô tả đội'}>
                <TextArea placeholder="Nhập mô tả" />
              </BaseFormItem>

              <BaseFormItem hiddenLabel>
                <ModalSelectTum
                  dataSelected={dataSelected}
                  onChangeTums={setDataSelected}
                  limit={action?.limit_member}
                />
              </BaseFormItem>
            </BaseSpace>
          </BaseForm>
        </BaseSpace>
      }
    />
  )
}

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px;
`
